import { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { postCostObjectsAPI } from '@/api/customerApi'
import Button from '@/components/form/Button'
import Input from '@/components/form/Input'
import { Translation } from '@/components/i18n/Translation'
import { fetchCostObjects } from '@/ducks/costObjectsReducer'
import { getCustomerId } from '@/ducks/customerReducer'
import { closePopup, setApiErrorPopup } from '@/ducks/popupReducer'

import './new-cost-object-form.scss'

const NewCostObjectForm = () => {
  const dispatch = useDispatch()

  const customerId = useSelector(getCustomerId)

  const [isPosting, setIsPosting] = useState(false)

  const [number, setNumber] = useState('')
  const [name, setName] = useState('')

  const postCostObject = () => {
    const post = async () => {
      setIsPosting(true)
      const costObject = {
        code: number,
        name,
      }

      try {
        await postCostObjectsAPI({ customerId, costObject })
        // @ts-ignore
        dispatch(fetchCostObjects(customerId))
        resetForm()
        dispatch(closePopup())
      } catch (error) {
        dispatch(setApiErrorPopup('Could not create cost object'))
        setIsPosting(false)
      }
    }
    !isPosting && post()
  }

  const resetForm = () => {
    setNumber('')
    setName('')
    setIsPosting(false)
  }

  return (
    <div className="new-cost-object-form">
      <Input
        label={<Translation id="Number" />}
        value={number}
        onChange={e => setNumber(e.target.value)}
        disabled={isPosting}
      />

      <Input
        label={<Translation id="Name" />}
        value={name}
        onChange={e => setName(e.target.value)}
        disabled={isPosting}
      />

      <Button disabled={isPosting} onClick={postCostObject}>
        <Translation id="Save" />
      </Button>
    </div>
  )
}

export default NewCostObjectForm
